import Vue from 'vue'
import VueRouter from 'vue-router'
import Partners from '../views/ReportPartnerSales.vue'
import ReportPartnerSales from '../views/ReportPartnerSales.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/partners' },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners
  },
  {
    path: '/report-partner-sales',
    name: 'ReportPartnerSales',
    component: ReportPartnerSales
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to, from) => {
  let msg = {
    'event': 'onNavigate',
    'data': {
      'from': from.fullPath,
      'to': to.fullPath,
    }
  };
  parent.postMessage(msg, '*');
})
export default router
